import ShowMore from "./ShowMore";

export default ShowMore;
